module.exports = __webpack_public_path__ + "img/Statistics.6868d1ed.svg";